// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"iP5jBlCi","row":"D1ZHnCeM","title":"z0GwnwXz","footer":"gGcuFmNi"};